import React, { type PropsWithChildren } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';

interface Props {
	title: string;
	description: string;
}

const BootstrapPage: React.FC<PropsWithChildren> = (props) => (
	<Box xcss={pageContainerStyles} testId="automation.automation-platform-bootstrap-error">
		<Box xcss={contentContainerStyles}>{props.children}</Box>
	</Box>
);

const BootstrapError: React.FC<Props> = (props) => (
	<BootstrapPage>
		<SectionMessage appearance="error" title={props.title}>
			{props.description}
		</SectionMessage>
	</BootstrapPage>
);

export default BootstrapError;

const pageContainerStyles = xcss({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: '80vh',
});

const contentContainerStyles = xcss({
	justifyContent: 'center',
	width: '500px',
});
